import { render, staticRenderFns } from "./DTESelector.vue?vue&type=template&id=23ed6fd9&scoped=true&lang=pug&"
import script from "./DTESelector.vue?vue&type=script&lang=js&"
export * from "./DTESelector.vue?vue&type=script&lang=js&"
import style0 from "./DTESelector.vue?vue&type=style&index=0&id=23ed6fd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ed6fd9",
  null
  
)

component.options.__file = "DTESelector.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
})
